import React, { AnchorHTMLAttributes, ButtonHTMLAttributes, FC } from 'react'
import { MinWidthProps, SpaceProps, WidthProps } from 'styled-system'
import { Icon } from '../Icon'
import Spinner from '../../rolex-ui/VideoPlayer/Spinner'
import * as S from './elements'
export type BaseButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  WidthProps &
  MinWidthProps &
  SpaceProps & {
    variant?: 'light' | 'dark' | 'outline' | 'rolex'
    status?: 'loading' | 'finished' | 'disabled' | 'idle'
  }

type Button = ButtonHTMLAttributes<HTMLButtonElement> & {
  as?: 'button'
}
type Link = AnchorHTMLAttributes<HTMLAnchorElement> & {
  as?: 'link'
  disabled?: boolean
}

type ButtonAs = Link | Button

export type ButtonProps = BaseButtonProps & ButtonAs

export const Button: FC<ButtonProps> = React.forwardRef(
  (
    {
      variant = 'light',
      status = 'idle',
      children,
      disabled,
      minWidth,
      width = 'auto',
      as = 'button',
      ...rest
    },
    outerRef
  ) => {
    const Comp: any = as === 'link' ? S.Link : S.Button

    // @ts-ignore
    if (process.env.NODE_ENV === 'development' && disabled) {
      console.error(
        `The 'disabled' prop is given, this won't be added to the button. Please use 'status="disabled" instead.'`
      )
    }
    return (
      <Comp
        {...rest}
        ref={outerRef}
        variant={variant}
        width={width}
        minWidth={minWidth}
        disabled={['loading', 'finished', 'disabled'].includes(status)}
        status={status}
      >
        <S.Content opacity={['loading', 'finished'].includes(status) ? 0 : 1}>{children}</S.Content>
        {status === 'loading' && (
          <S.IconParent>
            <Spinner size="1.25rem" />
          </S.IconParent>
        )}
        {status === 'finished' && (
          <S.IconParent>
            <Icon icon="check" />
          </S.IconParent>
        )}
      </Comp>
    )
  }
)

export default Button
